import { render, staticRenderFns } from "./ScriveSettings.vue?vue&type=template&id=d486fe3c&"
import script from "./ScriveSettings.vue?vue&type=script&lang=ts&"
export * from "./ScriveSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports